// Libs
import React from 'react'

// CSS
import './styles.scss'

const DashboardPill = ({ option, options, onClick }) => (
  <div className="dashboard-pill">
    {options.map((item, idx) => {
      const { label, value } = item
      return (
        <span
          key={value}
          className={option.value === value ? "dashboard-pill__pill dashboard-pill__pill--active" : "dashboard-pill__pill"}
          onClick={() => onClick(item, idx)}>
          {label}
        </span>
      )
    })}
  </div>
)

export default DashboardPill
